import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import { addDiscover, updateDiscover } from "./api";

function getFormattedDate(date) {
  var year = date.getFullYear();

  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;

  var day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;

  return month + '/' + day + '/' + year;
}

function toDateTime(secs) {
  var t = new Date(1970, 0, 1); // Epoch
  t.setSeconds(secs);

  return getFormattedDate(t);
}
function Add(props) {
  // ==================== GET DEFAULTS ==================== //
  const lState = props.location.state;
  const isAddPage = props.match.params.id === undefined;
  // ==================== GET DEFAULTS ==================== //

  // ==================== COMPONENET STATE ==================== //
  const [url, seturl] = useState(lState ? lState.url : "");
  const [title, settitle] = useState(lState ? lState.title : "");
  const [forInterceptor, setforInterceptor] = useState(
    lState ? lState.forInterceptor : false
  );
  const [published, setpublished] = useState(lState ? lState.published : false);

  const [bannerImage, setbannerImage] = useState(
    lState ? lState.bannerImage : ""
  );
  const [store, setStore] = useState(
    lState ? lState.store : ""
  );
  const [startDate, setStartDate] = useState(
    lState && lState.startDate && lState.startDate._seconds ? toDateTime(lState.startDate._seconds) : ""
  );
  const [endDate, setEndDate] = useState(
    lState && lState.endDate && lState.endDate._seconds ? toDateTime(lState.endDate._seconds) : ""
  );
  const [order, setOrder] = useState(
    lState ? lState.order : ""
  );
  const [status, setstatus] = useState(false);
  // ==================== COMPONENET STATE ==================== //

  // ==================== COMPONENT VARIABLES ==================== //
  let buttonText = "Submit";

  switch (status) {
    case "loading":
      buttonText = "Submitting...";
      break;
    case "success":
      buttonText = "Successful";
      break;
    case "error":
      buttonText = "Error";
      break;

    default:
      break;
  }
  // ==================== COMPONENT VARIABLES ==================== //

  return (
    <Wrapper>
      <form id="add-discover">
        <input
          className="field"
          name="url"
          placeholder="url"
          value={url}
          onBlur={(e) => {
            seturl(e.target.value);
          }}
          onChange={(e) => {
            let url = e.target.value;
            seturl(url);
          }}
        />
        <input
          className="field"
          name="title"
          placeholder="title"
          value={title}
          onChange={(e) => {
            settitle(e.target.value);
          }}
        />
        <input
          className="field"
          name="bannerImage"
          placeholder="bannerImage"
          value={bannerImage}
          onChange={(e) => {
            setbannerImage(e.target.value);
          }}
        />
        <input
          className="field"
          name="store"
          placeholder="store"
          value={store}
          onChange={(e) => {
            setStore(e.target.value);
          }}
        />
        <input
          className="field"
          name="startDate"
          placeholder="startDate MM/DD/YYYY"
          value={startDate}
          onChange={(e) => {
            setStartDate(`${e.target.value}`);
          }}
        />
        <input
          className="field"
          name="endDate"
          placeholder="endDate MM/DD/YYYY"
          value={endDate}
          onChange={(e) => {
            setEndDate(e.target.value);
          }}
        />
        <input
          className="field"
          name="order"
          placeholder="order"
          value={order}
          onChange={(e) => {
            setOrder(e.target.value);
          }}
        />
        <label style={{ display: "inline-block" }} htmlFor="forInterceptor">
          forInterceptor
        </label>
        <input
          type="checkbox"
          className="field"
          name="forInterceptor"
          placeholder="forInterceptor"
          value={forInterceptor}
          defaultChecked={forInterceptor}
          onChange={() => {
            setforInterceptor(!forInterceptor);
          }}
          style={{ display: "inline-block", width: "unset" }}
        />

        <label style={{ display: "inline-block" }} htmlFor="published">
          published
        </label>
        <input
          type="checkbox"
          className="field"
          name="published"
          placeholder="published"
          value={published}
          defaultChecked={published}
          onChange={() => {
            setpublished(!published);
          }}
          style={{ display: "inline-block", width: "unset" }}
        />

        <button
          onClick={async (e) => {
            e.preventDefault();
            let data = {};
            document
              .querySelector("#add-discover")
              .querySelectorAll(".field")
              .forEach((e) => {
                data[e.name] = e.value;
                if (e.name === "forInterceptor" || e.name === "published") {
                  data[e.name] = e.value === "true" ? true : false;
                }
                // if (e.name === "startDate" || e.name === "endDate") {
                //   data[e.name] = `${e.value} 23:59:59`
                // }
              });
            console.log(data);
            setstatus("loading");

            const res = isAddPage
              ? await addDiscover(data)
              : updateDiscover(props.match.params.id, data);
            if (res) {
              setstatus("success");
            } else {
              setstatus("error");
            }
          }}
        >
          {buttonText}
        </button>
      </form>
    </Wrapper>
  );
}

export default withRouter(Add);
// "name": "Amazon",
// "description": "Amazon.in: Online Shopping India - Buy mobiles, laptops, cameras, books, watches, apparel, shoes and e-Gift Cards. Free Shipping & Cash on Delivery Available.",
// "domain": "amazon",
// "URL": "https://www.amazon.in",
// "logo": "logo",
// "dSelectors": {"title":{"css":"h1.prod-name","type":"Text"},"price":{"css":"div.prod-sp","type":"Text"},"brand":{"css":"h2.brand-name","type":"Text"},"offers":{"css":"div.promo-blck","multiple":true,"type":"Text"},"size_instock":{"css":"div.size-instock","multiple":true,"type":"Text"},"size_outofstock":{"css":"div.swatch-size-oos","multiple":true,"type":"Text"},"details":{"css":"li.detail-list","multiple":true,"type":"Text"},"image":{"css":"img.rilrtl-lazy-img","type":"Attribute","attribute":"src"}},
// "mSelectors": {"title": { "css": "span[id=productTitle]", "type": "Text" },"price": [{ "css": "span[id=priceblock_ourprice]", "type": "Text" },{ "css": "span[id=priceblock_saleprice]", "type": "Text" },{ "css": "span[id=priceblock_dealprice]", "type": "Text" }],"tags": {"css": "div.a-breadcrumb a.a-link-normal","multiple": true,"type": "Text"},"description": {"css": "ul.a-unordered-list.a-spacing-mini li span.a-list-item","multiple": true,"type": "Text"},"image": {"css": "img[id=landingImage]","multiple": true,"type": "Attribute","attribute": "src"},"offers": {"css": "ul.a-unordered-list.a-spacing-small > li span.a-list-item","multiple": true,"type": "Text"}}
